import { HttpErrorResponse, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, of } from "rxjs";
import { Browser, Device, OS, Network } from "@app/core/models/deviceType.interface";
import { FormGroup } from "@angular/forms";
import { IdentityVerificationResponse } from "@app/pages/verify-identity/models/identity-verification.interface";

@Injectable({
	providedIn: "root",
})
export class UtilsService {
   
	wafToken: BehaviorSubject<string> = new BehaviorSubject('');
	private typeSendMethod: number = 1;
	private existOnboardingSubject = new BehaviorSubject<boolean>(false);

	private clientId = new BehaviorSubject<string>('');
	private userNameSubject = new BehaviorSubject<string>('');
	private idAccountObservable: BehaviorSubject<string> = new BehaviorSubject<string>("1");
	private emailClientObservable: BehaviorSubject<string> = new BehaviorSubject<string>("");
	private idClientObservable$: BehaviorSubject<string> = new BehaviorSubject<string>(null);
	private statusRequestObservable: BehaviorSubject<number> = new BehaviorSubject<number>(0);
	private productNumberObservable: BehaviorSubject<number> = new BehaviorSubject<number>(0);
	private countryClientObservable: BehaviorSubject<string> = new BehaviorSubject<string>("");
	private configAccessObservable: BehaviorSubject<string> = new BehaviorSubject<string>(null);
	private nationalityClientObservable: BehaviorSubject<number> = new BehaviorSubject<number>(0);
	private authGatewayTokenObservable: BehaviorSubject<string> = new BehaviorSubject<string>(null);
	private documentNumberClientObservable: BehaviorSubject<number> = new BehaviorSubject<number>(0);
	private agreementsTermsObservable: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
	private countryResidentClientObservable: BehaviorSubject<number> = new BehaviorSubject<number>(0);
	private identityVerificationResponseSubject = new BehaviorSubject<IdentityVerificationResponse>(null);
	private tokenRecaptchaObservable: BehaviorSubject<string> = new BehaviorSubject<string>(null);
	private hasExistUser: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
	private hasCryptoUser: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
	private isUpdateClient: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
	private identificationClientObservable: BehaviorSubject<'GovernmentId' | 'Passport'> = new BehaviorSubject<'GovernmentId' | 'Passport'>(null);
	private appianClientIdObservable: BehaviorSubject<string> = new BehaviorSubject<string>(null);
	
	// Nuevos campos para validación W9
	private placeOfBirthObservable: BehaviorSubject<number> = new BehaviorSubject<number>(0);
	private countryOfResidenceObservable: BehaviorSubject<number> = new BehaviorSubject<number>(0);
	private fiscalResidenceObservable: BehaviorSubject<number[]> = new BehaviorSubject<number[]>([]);

	objValidateUserOnline: {
		$type: string;
		TokenCrypto: string;
		UserName: string;
		DocumentNumber: string;
		DocumentType: { $type: string; DocumentTypeId: number };
	};

	objDeviceType: {
		browser: Browser;
		device:  Device;
		os:      OS;
		network: Network;
		screen:  Screen;
	}

	get getIdentityVerificationResponse(): Observable<IdentityVerificationResponse> {
		return this.identityVerificationResponseSubject.asObservable();
	}

	set setIdentityVerificationResponseData(data: any) {
		this.identityVerificationResponseSubject.next(data);
	}

	getIdentityVerificationResponseValue(): IdentityVerificationResponse {
		return this.identityVerificationResponseSubject.value;
	}

	get userNameObservable() {
		return this.userNameSubject.asObservable();
	}

	set setUserName(name: string) {
		if (name) {
			this.userNameSubject.next(name);
		}
	}

	// Obtener el nombre del usuario directamente
	getUserNameValue(): string {
		return this.userNameSubject.value;
	}

	get getExistOnboardingObservable(): Observable<boolean> {
        return this.existOnboardingSubject.asObservable();
    }

    set setExistOnboardingObservable(value: boolean) {
        this.existOnboardingSubject.next(value);
    }

	get getIdClientObservable() {
		return this.idClientObservable$.asObservable();
	}

	get getIdClient() {
		return this.idClientObservable$;
	}

	set setIdClientObservable(data: string) {
		this.clientId.next(data)
		this.idClientObservable$.next(data);
	}

	get getSharedTypeAccountObservable() {
		return this.idAccountObservable.asObservable();
	}

	set setSharedTypeAccountObservableData(data: string) {
		this.idAccountObservable.next(data);
	}

	get sharedEmailObservable() {
		return this.emailClientObservable.asObservable();
	}

	get getEmailObservableValue() {
		return this.emailClientObservable.value;
	}

	set sharedEmailObservableData(data: string) {
		this.emailClientObservable.next(data);
	}

	get sharedDocumentNumberObservable(): Observable<number> {
		return this.documentNumberClientObservable.asObservable();
	}

	set sharedDocumentNumberObservableData(data: number) {
		this.documentNumberClientObservable.next(data);
	}

	get sharedProductNumberObservable(): Observable<number> {
		return this.productNumberObservable.asObservable();
	}

	set sharedProductNumberObservableData(data: number) {
		this.productNumberObservable.next(data);
	}

	// Getters y Setters para validación W9 (Cliente existente sin cuenta cripto)
	get sharedNationalityObservable() {
		return this.nationalityClientObservable.asObservable();
	}

	set sharedNationalityData(data: number) {
		this.nationalityClientObservable.next(data);
	}
	
	get getSharedPlaceOfBirthObservable() {
		return this.placeOfBirthObservable.asObservable();
	}

	set setSharedPlaceOfBirthData(data: number) {
		this.placeOfBirthObservable.next(data);
	}

	get getSharedFiscalResidenceObservable() {
		return this.fiscalResidenceObservable.asObservable();
	}

	set setSharedFiscalResidenceData(data: number[]) {
		this.fiscalResidenceObservable.next(data);
	}

	get getSharedCountryOfResidenceObservable() {
		return this.countryOfResidenceObservable.asObservable();
	}

	set setSharedCountryOfResidenceData(data: number) {
		this.countryOfResidenceObservable.next(data);
	}
	
	// * Terminos y Condiciones check
	get sharedAgreementsObservable() {
		return this.agreementsTermsObservable.asObservable();
	}
	// * Terminos y Condiciones check
	set sharedAgreementsObservableData(data: boolean) {
		this.agreementsTermsObservable.next(data);
	}

	get statusObservable() {
		return this.statusRequestObservable.asObservable();
	}

	set statusObservableData(data: number) {
		this.statusRequestObservable.next(data);
	}

	get sharedCountryClientObservable() {
		return this.countryClientObservable.asObservable();
	}

	set sharedCountryClientObservableData(data: string) {
		this.countryClientObservable.next(data);
	}

	get sharedCountryResidentClientObservable() {
		return this.countryResidentClientObservable.asObservable();
	}

	set sharedCountryResidentClientObservableData(data: number) {
		this.countryResidentClientObservable.next(data);
	}

	set setTypeSendMethodCard(typeSend: number) {
		this.typeSendMethod = typeSend;
	}

	get getTypeSendMethodCard(): number {
		return this.typeSendMethod;
	}

	set setHasExistUser(data: boolean) {
		this.hasExistUser.next(data);
	}

	get getHasExistUser() {
		return this.hasExistUser.value;
	}

	set setHasCryptoUser(data: boolean) {
		this.hasCryptoUser.next(data);
	}

	get getHasCryptoUser() {
		return this.hasCryptoUser.value;
	}

	get getIsUpdateClient(): boolean {
		return this.isUpdateClient.value;
	}

	set setIsUpdateClient(data: boolean) {
		this.isUpdateClient.next(data);
	}

	// * Manejo de tipos de documento
	get getDocumentType$() {
        return this.identificationClientObservable.asObservable();
    }

	set setDocumentType(value: 'GovernmentId' | 'Passport') {
        this.identificationClientObservable.next(value);
    }
	// * Obtenemos el valor del tipo de documento, ya sea GovernmentId o Passport
	getDocumentTypeValue(): string {
		return this.identificationClientObservable.value;
	}

	get configAccess(): Observable<string> {
		return this.configAccessObservable.asObservable();
	}

	set configAccess(value: string) {
		this.configAccessObservable.next(value);
	}
	
	getConfigAccessValue(): string {
		return this.configAccessObservable.value;
	}

	// * Appian Client Id
	set setAppianClientId(value: string) {
		this.appianClientIdObservable.next(value);
	}

	get appianClientId(): Observable<string> {
		return this.appianClientIdObservable.asObservable();
	}

	get getAppianClientId(): string {
		return this.appianClientIdObservable.value;
	}

	// * Auth Gateway Token
	get authGatewayToken(): Observable<string> {
		return this.authGatewayTokenObservable.asObservable();
	}
	set authGatewayToken(value: string) {
		this.authGatewayTokenObservable.next(value);
	}
	getAuthGatewayTokenValue(): string {
		return this.authGatewayTokenObservable.value;
	}
	
	// * Recaptcha
	get tokenRecaptcha(): Observable<string> {
		return this.tokenRecaptchaObservable.asObservable();
	}
	set tokenRecaptcha(value: string) {
		this.tokenRecaptchaObservable.next(value);
	}
	getTokenRecaptchaValue(): string {
		return this.tokenRecaptchaObservable.value;
	}

	public clearAppState(): void {
		this.configAccessObservable.next(null);
		this.authGatewayTokenObservable.next(null);
		this.tokenRecaptchaObservable.next(null);
		// optionally clear other state variables as needed
	}

	public buildValidateUser(document: string, documentTypeId: number): void {

		this.objValidateUserOnline = {
			$type:
				"Tailored.ICBanking.UIProcess.MethodParameters.Framework.CryptoCustom.ValidateUserDataIn, Tailored.ICBanking.UIProcess",
			TokenCrypto:
				"XXXXXXXSXSXSXSXSXSXSXSXSXSXXSPLPLXPLPSLXPSLXPSLSPLPLSPLSPLPLSX",
			UserName: " ",
			DocumentNumber: document,
			DocumentType: {
				$type:
					"Infocorp.UIProcess.Entities.Framework.Common.DocumentType, Infocorp.UIProcess.Entities",
				DocumentTypeId: documentTypeId,
			},
		};
	}

	get getObjectValidateUserOnline() {
		return this.objValidateUserOnline;
	}

	public setDeviceType(deviceType: any)  {
		this.objDeviceType = deviceType;
	}
	
	get getDeviceType() {
		return this.objDeviceType;
	}

	/**
	 * Maneja la entrada de zipCode para eliminar espacios en blanco
	 * @param event Evento de entrada
	 * @param form Formulario que contiene el campo zipCode
	 * @param fieldName Nombre del campo (por defecto 'zipCode')
	 */
	public handleZipCodeInput(event: Event, form: FormGroup, fieldName: string = 'zipCode'): void {
		const input = event.target as HTMLInputElement;
		if (input?.value) {
			// Eliminar espacios en blanco
			const trimmedValue = input.value.trim();
			
			// Solo actualizar si es diferente para evitar ciclo infinito
			if (trimmedValue !== input.value) {
				input.value = trimmedValue;
				form.get(fieldName)?.setValue(trimmedValue);
			}
		}
	}

	/**
	 * Limpia el campo zipCode de espacios en blanco
	 * @param zipCode Valor del código postal
	 * @returns Código postal limpio
	 */
	public cleanZipCode(zipCode: any): string {
		if (zipCode === undefined || zipCode === null) {
			return '';
		}
		return typeof zipCode === 'string' ? zipCode.trim() : zipCode;
	}

	/**
	 * Handles response
	 * Método para manejar las respuestas de api.
	 * @param res
	 * @returns
	 */
	handleResponse(res: any) {
		switch (res.status) {
			case 200:
			case 201:
			case 204:
				return res.body || "unhandled response";
			default:
				return this.handleError(res);
		}
	}

	/**
	 * Handles error
	 * Método para controlar los errores desde api.
	 * @param error
	 * @returns
	 */
	handleError(error: HttpErrorResponse) {
		return of(error);
	}

	/**
	 * Sets query params
	 * Método para crear los parametros por url.
	 * @param pageIndex
	 * @param pageSize
	 * @returns
	 */
	setQueryParams(pageIndex: number, pageSize: number) {
		const params = new HttpParams()
			.set("offset", pageIndex)
			.set("limit", pageSize);
		return params;
	}
	
	setParams(idCountry: number, idProvince?: number): HttpParams {
		return new HttpParams()
			.set("countryId", idCountry)
			.set("provinceId", idProvince)
			.set("pageSize", "5000");
	}

	exposeClientDocumentNumber(): number{
		return this.documentNumberClientObservable.getValue();
	}
}